import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Eye, EyeOff } from 'lucide-react';
import { useWholesaleAuth } from '../context/WholesaleAuthContext';

const LOGO_URL = "/images/wayside-logo-horizontal.png";

const WholesaleLoginPage = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const { login } = useWholesaleAuth();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setIsLoading(true);
        try {
            await login(email, password);
            navigate('/wholesale/products');
        } catch {
            setError('Invalid credentials');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-maple-dark flex items-center justify-center px-6" data-testid="wholesale-login-page">
            <div className="w-full max-w-md">
                <div className="text-center mb-12">
                    <img src={LOGO_URL} alt="Wayside Maple" className="h-12 w-auto mx-auto brightness-0 invert mb-8" />
                    <h1 className="font-anton text-3xl text-white">WHOLESALE PORTAL</h1>
                    <p className="text-white/50 mt-3">Sign in to place batch wholesale orders.</p>
                </div>
                <div className="bg-maple-card border border-white/10 p-8 md:p-10">
                    {error && <div className="bg-red-900/30 border border-red-500/30 text-red-400 p-4 mb-6">{error}</div>}
                    <form onSubmit={handleSubmit} className="space-y-6">
                        <div>
                            <label className="block text-white/40 text-sm uppercase tracking-wider mb-2">Email</label>
                            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="w-full" placeholder="Enter email" />
                        </div>
                        <div>
                            <label className="block text-white/40 text-sm uppercase tracking-wider mb-2">Password</label>
                            <div className="relative">
                                <input type={showPassword ? 'text' : 'password'} value={password} onChange={(e) => setPassword(e.target.value)} required className="w-full pr-12" placeholder="Enter password" />
                                <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute right-0 top-1/2 -translate-y-1/2 p-3 text-white/40 hover:text-white transition-colors">
                                    {showPassword ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
                                </button>
                            </div>
                        </div>
                        <button type="submit" disabled={isLoading} className="btn-primary w-full disabled:opacity-50">
                            <span>{isLoading ? 'Signing in...' : 'Access Wholesale Portal'}</span>
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default WholesaleLoginPage;
